import {
    FETCH_ASSESSMENTS_REQUEST,
    FETCH_ASSESSMENTS_SUCCESS,
    FETCH_ASSESSMENTS_FAILURE,

    CREATE_ASSESSMENT_REQUEST,
    CREATE_ASSESSMENT_SUCCESS,
    CREATE_ASSESSMENT_FAILURE,

    UPDATE_ASSESSMENT_REQUEST,
    UPDATE_ASSESSMENT_SUCCESS,
    UPDATE_ASSESSMENT_FAILURE,

    DELETE_ASSESSMENT_REQUEST,
    DELETE_ASSESSMENT_SUCCESS,
    DELETE_ASSESSMENT_FAILURE,
} from "./types";


import {
    fetchAssessments,
    createAssessment,
    updateAssessment,
    deleteAssessment,
} from "../../services/assessmentService";



export const fetchAssessmentsRequest = () => ({
    type: FETCH_ASSESSMENTS_REQUEST,
});


export const fetchAssessmentsSuccess = (
    assessments
) => ({
    type: FETCH_ASSESSMENTS_SUCCESS,
    payload: assessments,
});


export const fetchAssessmentsFailure = (
    error
) => ({
    type: FETCH_ASSESSMENTS_FAILURE,
    payload: error,
});



export const createAssessmentRequest = () => ({
    type: CREATE_ASSESSMENT_REQUEST,
});


export const createAssessmentSuccess = (
    assessment
) => ({
    type: CREATE_ASSESSMENT_SUCCESS,
    payload: assessment,
});


export const createAssessmentFailure = (
    error
) => ({
    type: CREATE_ASSESSMENT_FAILURE,
    payload: error,
});



export const updateAssessmentRequest = () => ({
    type: UPDATE_ASSESSMENT_REQUEST,
});


export const updateAssessmentSuccess = (
    assessment
) => ({
    type: UPDATE_ASSESSMENT_SUCCESS,
    payload: assessment,
});


export const updateAssessmentFailure = (
    error
) => ({
    type: UPDATE_ASSESSMENT_FAILURE,
    payload: error,
});



export const deleteAssessmentRequest = () => ({
    type: DELETE_ASSESSMENT_REQUEST,
});


export const deleteAssessmentSuccess = (
    assessmentId
) => ({
    type: DELETE_ASSESSMENT_SUCCESS,
    payload: assessmentId,
});


export const deleteAssessmentFailure = (
    error
) => ({
    type: DELETE_ASSESSMENT_FAILURE,
    payload: error,
});

export const fetchAssessmentsAction =
    () => async (dispatch) => {

        dispatch(
            fetchAssessmentsRequest()
        );

        try {

            const response =
                await fetchAssessments();

            if (response.success) {

                dispatch(
                    fetchAssessmentsSuccess(
                        response.data
                    )
                );

                return {
                    success: true,
                    data: response.data,
                };

            }

            dispatch(
                fetchAssessmentsFailure(
                    response.error
                )
            );

            return {
                success: false,
                error: response.error,
            };

        } catch (error) {

            const message =
                error.message ||
                "Failed to fetch assessments";

            dispatch(
                fetchAssessmentsFailure(
                    message
                )
            );

            return {
                success: false,
                error: message,
            };

        }
    };



export const createAssessmentAction =
    (payload) => async (dispatch) => {

        dispatch(
            createAssessmentRequest()
        );

        try {

            const response =
                await createAssessment(
                    payload
                );

            if (response.success) {

                dispatch(
                    createAssessmentSuccess(
                        response.data
                    )
                );

                return {
                    success: true,
                    data: response.data,
                };

            }

            dispatch(
                createAssessmentFailure(
                    response.error
                )
            );

            return {
                success: false,
                error: response.error,
            };

        } catch (error) {

            const message =
                error.message ||
                "Failed to create assessment";

            dispatch(
                createAssessmentFailure(
                    message
                )
            );

            return {
                success: false,
                error: message,
            };

        }
    };



export const updateAssessmentAction =
    (
        assessmentId,
        payload
    ) => async (dispatch) => {

        dispatch(
            updateAssessmentRequest()
        );

        try {

            const response =
                await updateAssessment(
                    assessmentId,
                    payload
                );

            if (response.success) {

                dispatch(
                    updateAssessmentSuccess(
                        response.data
                    )
                );

                return {
                    success: true,
                    data: response.data,
                };

            }

            dispatch(
                updateAssessmentFailure(
                    response.error
                )
            );

            return {
                success: false,
                error: response.error,
            };

        } catch (error) {

            const message =
                error.message ||
                "Failed to update assessment";

            dispatch(
                updateAssessmentFailure(
                    message
                )
            );

            return {
                success: false,
                error: message,
            };

        }
    };



export const deleteAssessmentAction =
    (assessmentId) => async (dispatch) => {

        dispatch(
            deleteAssessmentRequest()
        );

        try {

            const response =
                await deleteAssessment(
                    assessmentId
                );

            if (response.success) {

                dispatch(
                    deleteAssessmentSuccess(
                        assessmentId
                    )
                );

                return {
                    success: true,
                    data: response.data,
                    message:
                        response.message,
                };

            }

            dispatch(
                deleteAssessmentFailure(
                    response.error
                )
            );

            return {
                success: false,
                error: response.error,
            };

        } catch (error) {

            const message =
                error.message ||
                "Failed to delete assessment";

            dispatch(
                deleteAssessmentFailure(
                    message
                )
            );

            return {
                success: false,
                error: message,
            };

        }
    };